module.exports = __webpack_public_path__ + "img/petbanners.5d361df9.png";